import { createAsyncTypes } from 'utils/ActionCreator'

const key = 'FirstLoginModal'

export const SUBMIT_FIRST_LOGIN_ASYNC = createAsyncTypes('SUBMIT_FIRST_LOGIN', key)
